import React, { useState } from 'react';

import ResizableTable from '../../../foundation/components/resizable_table/ResizableTable';
import { useGetVariantReferencesQuery } from '../../api/variantApi';
import { Reference } from '../redux';
import ReferenceModal from './ReferenceModal';
import { referencesTableColumns } from './referencesTableColumns';

type ReferencesOverviewProps = {
  variantId: string | undefined;
  filterByType?: string | ((type: string) => boolean);
  stageType?: string;
};

const ReferencesOverview = ({
  variantId,
  filterByType,
  stageType,
}: ReferencesOverviewProps) => {
  // Read references straight from the query hook's cache. Default to [] so
  // .filter() below never crashes while the request is in flight
  const { data: references = [], isLoading: isReferencesLoading } =
    useGetVariantReferencesQuery(
      { variant_id: variantId },
      { skip: !variantId },
    );

  const [isReferenceModalOpen, setIsReferenceModalOpen] = useState(false);

  const [currentReference, setCurrentReference] = useState<
    Reference | undefined
  >(undefined);

  const filteredReferences = filterByType
    ? references.filter((ref: any) =>
        typeof filterByType === 'function'
          ? filterByType(ref.type)
          : ref.type === filterByType,
      )
    : references;

  const handleResourceEditClick = (record: any) => {
    setCurrentReference(record);
    setIsReferenceModalOpen(true);
  };

  const handleReferenceModalClose = () => {
    setIsReferenceModalOpen(false);
    setCurrentReference(undefined);
  };

  return (
    <>
      {isReferenceModalOpen && (
        <ReferenceModal
          closeModal={handleReferenceModalClose}
          type="edit"
          currentValues={currentReference}
          stageType={stageType}
        />
      )}
      <ResizableTable
        columns={referencesTableColumns(filterByType, handleResourceEditClick)}
        dataSource={filteredReferences}
        loading={isReferencesLoading}
        rowKey={(record) => record.id}
        pagination={false}
        persistenceKey={`references-${stageType ?? 'all'}`}
      />
    </>
  );
};

export default ReferencesOverview;
